export const FEATURED_FLAG_KEY_MAPPING = {
  sm405errorModal: "405-error-snack-magic-modal",
  displayStripeOriginalPaymentErrorMessage: "display-stripe-original-payment-error",
  sendPointsInviteContacts: "send-points-invite-contacts",
  addRecipientContactWidget: "add-recipient-contact-widget",
  addRecipientContactWidgetIncludeKit: "add-recipient-contact-widget-include-kit",
  permissionV1: "permission-system-v1",
  medleysCDNMigration: "medleys-cdn-migration",
  feAuthorizationDebugMode: "fe-authorization-debug-mode",
  eshopCacheStoreApi: "eshops-cache-store-api",
  customDomainDashboardConfig: "custom-domain-dashboard-config",
  companySpaceSharedWalletAccess: "company-space-shared-wallet-access",
  pastelPageNewProductUi: "pastel-page-new-product-ui",
  companySpaceIntegrationTab: "company-space-integration-tab",
  quickRecogniseWidget: "quick-recognise-widget",
  workspaceSettings: "workspace-settings",
  workspaceRouteUpdate: "workspace-route-update",
  stadiumShopsCspPolicy: "stadium-shops-csp-policy-json",
  leftNavBarUpdates: "left-nav-bar-updates",
  workspaceSidebar: "workspace-sidebar",
  workspacePermission: "workspace-permission",
  multipleGtm: "multiple-gtm",
  workspaceDashboard: "workspace-dashboard",
  workspaceWallet: "workspace-wallet",
  workspaceContacts: "workspace-contacts",
  workspaceManageAll: "workspace-manage-all",
  workspaceDefaultLogin: "workspace-default-login",
  requestToJoinWorkspace: "request-to-join-workspace",
  workspaceCreatedByFilter: "workspace-created-by-filter",
  appGenericAnnouncementBar: "app-generic-announcement-bar",
  siteDownMaintenancePage: "site-down-maintainence-page",
  workspaceLaunch: "workspace-launch",
  previewCatalogIncludeInactiveProducts: "preview-catalog-include-inactive-products",
  disableSearchInShops: "disable-search-in-shops",
  p2pDynamicFilters: "p2p-dynamic-filters",
  companySpacePermissionList: "company-space-permission-list",
  workspaceSharedWallet: "workspace-shared-wallet",
  campaignHistory: "campaign-history",
  variantListLimitQueryFields: "variant-list-limit-query-fields",
  eadBanner: "ead-banner",
  dashboardEadBanner: "dashboard-ead-banner",
  storeMetaDetails: "store-meta-details",
  workspaceUserDeactivation: "workspace-user-deactivation",
  allowRecognitionWithoutKudos: "allow-recognition-without-kudos",
  pricelessEditCatalog: "priceless-edit-catalog-changes",
  contactPiiUpdates: "contact-pii-updates",
  personalWorkspaceNudge: "personal-workspace-nudge",
  shopPrivateAccessDenied: "shop-private-access-denied",
  lockerIdChange: "locker-id-change",
  createWorkspaceNudge: "create-workspace-nudge",
  upcomingGiftUpdate: "upcoming-gift-update",
  hubspotContextRefactor: "hubspot-context-refactor",
  stadiumShopsStripConfigPayload: "stadium-shops-strip-config-payload",
  swagmagicPersonalSpaceLinkFix: "swagmagic-personal-space-link-fix",
  quickRecogniseRevamp: "quick-recognise-revamp",
  hideCreateNewWorkspace: "hide-create-new-workspace",
  goCatalogUseSwagmagicShop: "go-catalog-use-swagmagic-shop",
  roleBasedWorkspacePermissions: "role-based-workspace-permissions",
  hideDashboardHelpLinks: "hide-dashboard-help-links",
  kudosProgramPresent: "kudos-program-present",
  hidePinnedShopsConfig: "hide-pinned-shops-config",
  lockerProductMasterId: "locker-product-master-id",
  variantLevelMoq: "variant-level-moq",
  hideCategoryReport: "hide-category-report",
  inProgressRecipientsTab: "in-progress-recipients-tab-fe",
  thankYouMessagePromptSettings: "thank-you-message-prompt-settings",
  hideAdminNameInWalletHistoryFE: "hide-admin-name-in-wallet-history-fe",
  recognitionFeedFilters: "recognition-feed-filters",
  contactInfinitePagination: "contact-infinite-pagination",
  shipmentGrouping: "shipment-grouping",
  assetLibraryFe: "asset-library-fe",
  datadogSessionSampleRate: "datadog-session-sample-rate",
  addressFormNoTranslation: "address-form-no-translation",
  logoQualityUpdates: "fe-logo-quality-updates",
  automationThankYouMessageSettings: "automation-thank-you-message-settings",
  previewPmtMockup: "preview-pmt-mockup",
  mixpanelRecordCanvas: "mixpanel-record-canvas",
  separateListingForLeadOrdersFe: "separate-listing-for-lead-orders-fe",
  attachVideoMessageInAutomation: "attach-video-message-in-automation",
  automationViewFiltersTooltip: "automation-view-filters-tooltip-fe",
  productStoreNumber: "product-store-number",
  kitBundleProductVariantsApi: "kit-bundle-product-variants-api",
  threePlWarehouseUpdates: "three-pl-warehouse-updates",
  campaignEnableAppliedFilters: "campaign-enable-applied-filters",
  contactFilterUiChanges: "contact-filter-ui-changes",
  showWorkspacePrivacyOption: "show-workspace-privacy-option",
  contactFilterAggregations: "contact-filter-aggregations",
  updateRecipientMetrics: "update-recipient-metrics",
  orderContactsRecipientSearch: "order-contacts-recipient-search",
  collectionFilterProductListing: "collection-filter-product-listing",
  catalogAssociatedCollectionsFirstOrder: "catalog-associated-collections-first-order",
  newFrequencyOptions: "new-frequency-options",
  shopAllowAllUsersSendSettings: "shop-allow-all-users-send-settings",
};

export const {
  sm405errorModal: sm405errorModalFeatureFlag,
  displayStripeOriginalPaymentErrorMessage: displayStripeOriginalPaymentErrorMessageFlag,
  sendPointsInviteContacts: sendPointsInviteContactsFlag,
  addRecipientContactWidget: addRecipientContactWidgetFlag,
  addRecipientContactWidgetIncludeKit: addRecipientContactWidgetIncludeKitFlag,
  permissionV1: permissionV1Flag,
  medleysCDNMigration: medleysCDNMigrationFlag,
  feAuthorizationDebugMode: feAuthorizationDebugModeFlag,
  eshopCacheStoreApi: eshopCacheStoreApiFlag,
  customDomainDashboardConfig: customDomainDashboardConfigFlag,
  companySpaceSharedWalletAccess: companySpaceSharedWalletAccessFlag,
  pastelPageNewProductUi: pastelPageNewProductUiFlag,
  companySpaceIntegrationTab: companySpaceIntegrationTabFlag,
  quickRecogniseWidget: quickRecogniseWidgetFlag,
  workspaceSettings: workspaceSettingsFlag,
  workspaceRouteUpdate: workspaceRouteUpdateFlag,
  stadiumShopsCspPolicy: stadiumShopsCspPolicyFlag,
  leftNavBarUpdates: leftNavBarUpdatesFlag,
  workspaceSidebar: workspaceSidebarFlag,
  workspacePermission: workspacePermissionFlag,
  multipleGtm: multipleGtmFlag,
  workspaceDashboard: workspaceDashboardFlag,
  workspaceWallet: workspaceWalletFlag,
  workspaceContacts: workspaceContactsFlag,
  workspaceManageAll: workspaceManageAllFlag,
  workspaceDefaultLogin: workspaceDefaultLoginFlag,
  requestToJoinWorkspace: requestToJoinWorkspaceFlag,
  workspaceCreatedByFilter: workspaceCreatedByFilterFlag,
  appGenericAnnouncementBar: appGenericAnnouncementBarFlag,
  siteDownMaintenancePage: siteDownMaintenancePageFlag,
  workspaceLaunch: workspaceLaunchFlag,
  previewCatalogIncludeInactiveProducts: previewCatalogIncludeInactiveProductsFlag,
  disableSearchInShops: disableSearchInShopsFlag,
  p2pDynamicFilters: p2pDynamicFiltersFlag,
  companySpacePermissionList: companySpacePermissionListFlag,
  workspaceSharedWallet: workspaceSharedWalletFlag,
  campaignHistory: campaignHistoryFlag,
  variantListLimitQueryFields: variantListLimitQueryFieldsFlag,
  eadBanner: eadBannerFlag,
  dashboardEadBanner: dashboardEadBannerFlag,
  storeMetaDetails: storeMetaDetailsFlag,
  workspaceUserDeactivation: workspaceUserDeactivationFlag,
  allowRecognitionWithoutKudos: allowRecognitionWithoutKudosFlag,
  pricelessEditCatalog: pricelessEditCatalogFlag,
  contactPiiUpdates: contactPiiUpdatesFlag,
  personalWorkspaceNudge: personalWorkspaceNudgeFlag,
  shopPrivateAccessDenied: shopPrivateAccessDeniedFlag,
  lockerIdChange: lockerIdChangeFlag,
  createWorkspaceNudge: createWorkspaceNudgeFlag,
  upcomingGiftUpdate: upcomingGiftUpdateFlag,
  hubspotContextRefactor: hubspotContextRefactorFlag,
  stadiumShopsStripConfigPayload: stadiumShopsStripConfigPayloadFlag,
  swagmagicPersonalSpaceLinkFix: swagmagicPersonalSpaceLinkFixFlag,
  quickRecogniseRevamp: quickRecogniseRevampFlag,
  hideCreateNewWorkspace: hideCreateNewWorkspaceFlag,
  goCatalogUseSwagmagicShop: goCatalogUseSwagmagicShopFlag,
  roleBasedWorkspacePermissions: roleBasedWorkspacePermissionsFlag,
  hideDashboardHelpLinks: hideDashboardHelpLinksFlag,
  kudosProgramPresent: kudosProgramPresentFlag,
  hidePinnedShopsConfig: hidePinnedShopsConfigFlag,
  lockerProductMasterId: lockerProductMasterIdFlag,
  variantLevelMoq: variantLevelMoqFlag,
  hideCategoryReport: hideCategoryReportFlag,
  inProgressRecipientsTab: inProgressRecipientsTabFlag,
  thankYouMessagePromptSettings: thankYouMessagePromptSettingsFlag,
  hideAdminNameInWalletHistoryFE: hideAdminNameInWalletHistoryFEFlag,
  recognitionFeedFilters: recognitionFeedFiltersFlag,
  contactInfinitePagination: contactInfinitePaginationFlag,
  shipmentGrouping: shipmentGroupingFlag,
  assetLibraryFe: assetLibraryFeFlag,
  datadogSessionSampleRate: datadogSessionSampleRateFlag,
  addressFormNoTranslation: addressFormNoTranslationFlag,
  logoQualityUpdates: logoQualityUpdatesFlag,
  automationThankYouMessageSettings: automationThankYouMessageSettingsFlag,
  previewPmtMockup: previewPmtMockupFlag,
  mixpanelRecordCanvas: mixpanelRecordCanvasFlag,
  separateListingForLeadOrdersFe: separateListingForLeadOrdersFeFlag,
  attachVideoMessageInAutomation: attachVideoMessageInAutomationFlag,
  automationViewFiltersTooltip: automationViewFiltersTooltipFlag,
  productStoreNumber: productStoreNumberFlag,
  kitBundleProductVariantsApi: kitBundleProductVariantsApiFlag,
  threePlWarehouseUpdates: threePlWarehouseUpdatesFlag,
  campaignEnableAppliedFilters: campaignEnableAppliedFiltersFlag,
  contactFilterUiChanges: contactFilterUiChangesFlag,
  showWorkspacePrivacyOption: showWorkspacePrivacyOptionFlag,
  contactFilterAggregations: contactFilterAggregationsFlag,
  updateRecipientMetrics: updateRecipientMetricsFlag,
  orderContactsRecipientSearch: orderContactsRecipientSearchFlag,
  collectionFilterProductListing: collectionFilterProductListingFlag,
  catalogAssociatedCollectionsFirstOrder: catalogAssociatedCollectionsFirstOrderFlag,
  newFrequencyOptions: newFrequencyOptionsFlag,
  shopAllowAllUsersSendSettings: shopAllowAllUsersSendSettingsFlag,
} = FEATURED_FLAG_KEY_MAPPING;

export const DEFAULT_REACT_OPTIONS = { useCamelCaseFlagKeys: false };

export const LAUNCH_DARKLY_ANONYMOUS_USER_CONFIG = { kind: "user", key: "GLOBAL", anonymous: true };

export const generateLaunchDarklyContext = (email?: string, ip?: string | null) => {
  const baseContext = email
    ? { kind: "user" as const, key: email, email, anonymous: false }
    : LAUNCH_DARKLY_ANONYMOUS_USER_CONFIG;
  return ip ? { ...baseContext, ip } : baseContext;
};

export const LAUNCH_DARKLY_DEFAULT_FLAGS = {
  [sm405errorModalFeatureFlag]: false,
  [displayStripeOriginalPaymentErrorMessageFlag]: false,
  [sendPointsInviteContactsFlag]: false,
  [addRecipientContactWidgetFlag]: false,
  [addRecipientContactWidgetIncludeKitFlag]: false,
  [permissionV1Flag]: false,
  [medleysCDNMigrationFlag]: false,
  [feAuthorizationDebugModeFlag]: false,
  [customDomainDashboardConfigFlag]: false,
  [companySpaceSharedWalletAccessFlag]: false,
  [pastelPageNewProductUiFlag]: false,
  [companySpaceIntegrationTabFlag]: false,
  [quickRecogniseWidgetFlag]: false,
  [workspaceSettingsFlag]: false,
  [workspaceRouteUpdateFlag]: false,
  [leftNavBarUpdatesFlag]: false,
  [workspaceSidebarFlag]: false,
  [workspacePermissionFlag]: false,
  [multipleGtmFlag]: "",
  [workspaceDashboardFlag]: false,
  [workspaceWalletFlag]: false,
  [workspaceContactsFlag]: true,
  [workspaceManageAllFlag]: false,
  [workspaceDefaultLoginFlag]: false,
  [requestToJoinWorkspaceFlag]: false,
  [workspaceCreatedByFilterFlag]: false,
  [appGenericAnnouncementBarFlag]: false,
  [siteDownMaintenancePageFlag]: false,
  [workspaceLaunchFlag]: false,
  [previewCatalogIncludeInactiveProductsFlag]: false,
  [disableSearchInShopsFlag]: false,
  [p2pDynamicFiltersFlag]: false,
  [companySpacePermissionListFlag]: false,
  [workspaceSharedWalletFlag]: false,
  [campaignHistoryFlag]: false,
  [variantListLimitQueryFieldsFlag]: false,
  [eadBannerFlag]: false,
  [dashboardEadBannerFlag]: false,
  [storeMetaDetailsFlag]: null,
  [workspaceUserDeactivationFlag]: false,
  [allowRecognitionWithoutKudosFlag]: false,
  [pricelessEditCatalogFlag]: false,
  [contactPiiUpdatesFlag]: false,
  [personalWorkspaceNudgeFlag]: false,
  [shopPrivateAccessDeniedFlag]: false,
  [lockerIdChangeFlag]: false,
  [createWorkspaceNudgeFlag]: false,
  [upcomingGiftUpdateFlag]: false,
  [hubspotContextRefactorFlag]: false,
  [stadiumShopsStripConfigPayloadFlag]: false,
  [swagmagicPersonalSpaceLinkFixFlag]: false,
  [quickRecogniseRevampFlag]: true,
  [hideCreateNewWorkspaceFlag]: false,
  [goCatalogUseSwagmagicShopFlag]: false,
  [campaignEnableAppliedFiltersFlag]: false,
  [roleBasedWorkspacePermissionsFlag]: {
    sender: {},
    admin: {},
    owner: {},
    member: {},
    personalWorkspace: {},
  },
  [hideDashboardHelpLinksFlag]: {},
  [kudosProgramPresentFlag]: false,
  [hidePinnedShopsConfigFlag]: {},
  [lockerProductMasterIdFlag]: false,
  [variantLevelMoqFlag]: false,
  [hideCategoryReportFlag]: false,
  [inProgressRecipientsTabFlag]: false,
  [thankYouMessagePromptSettingsFlag]: false,
  [hideAdminNameInWalletHistoryFEFlag]: false,
  [recognitionFeedFiltersFlag]: false,
  [contactInfinitePaginationFlag]: false,
  [shipmentGroupingFlag]: false,
  [assetLibraryFeFlag]: false,
  [datadogSessionSampleRateFlag]: { sessionSampleRate: 100, sessionSampleReplayRate: 0 },
  [addressFormNoTranslationFlag]: "all",
  [logoQualityUpdatesFlag]: false,
  [automationThankYouMessageSettingsFlag]: false,
  [previewPmtMockupFlag]: false,
  [mixpanelRecordCanvasFlag]: false,
  [separateListingForLeadOrdersFeFlag]: false,
  [attachVideoMessageInAutomationFlag]: false,
  [automationViewFiltersTooltipFlag]: false,
  [productStoreNumberFlag]: false,
  [kitBundleProductVariantsApiFlag]: false,
  [threePlWarehouseUpdatesFlag]: false,
  [contactFilterUiChangesFlag]: false,
  [showWorkspacePrivacyOptionFlag]: false,
  [contactFilterAggregationsFlag]: false,
  [updateRecipientMetricsFlag]: false,
  [orderContactsRecipientSearchFlag]: false,
  [collectionFilterProductListingFlag]: false,
  [catalogAssociatedCollectionsFirstOrderFlag]: false,
  [newFrequencyOptionsFlag]: false,
  [shopAllowAllUsersSendSettingsFlag]: false,
};
